<template>
  <div>
    <vs-row class="mb-3">
      <vs-button color="dark" disabled type="flat"
        ><h5>Device Management / Alert</h5></vs-button
      >
    </vs-row>
    <vs-card style="border-radius: 20px">
      <div class="mt-2" slot="header">
        <vs-row id="center">
          <h3 id="p" style="color: #111111">Alert</h3>
          <h3 id="v" style="color: #111111">Alert</h3>
          <vs-spacer />
          <vs-tooltip text="Print" position="top">
            <vs-button
              radius
              class="mr-2"
              color="#333f50"
              type="line"
              @click="print"
              icon="print"
            ></vs-button
          ></vs-tooltip>
          <vs-tooltip text="Download a PDF" position="top">
            <vs-button
              radius
              class="mr-2"
              color="#333f50"
              @click="exportPDF"
              type="line"
              icon="picture_as_pdf"
            ></vs-button
          ></vs-tooltip>
          <vs-tooltip text="Export" position="top">
            <vs-button
              class="mr-2"
              radius
              @click="onExport"
              color="#333f50"
              type="line"
              icon="cloud_download"
            ></vs-button
          ></vs-tooltip>
        </vs-row>
      </div>
      <vs-row class="mt-4 mb-3">
        <vs-col
          style="padding-left: unset"
          vs-type="flex"
          vs-align="center"
          vs-lg="6"
          vs-sm="6"
          vs-xs="12"
        >
          <h6>Filters :</h6>
          <v-select
            style="min-width: 300px"
            class="ml-3"
            multiple
            v-model="selectFilter"
            :options="header"
          />
          <vs-icon
            class="ml-2"
            icon="search"
            id="btns"
            @click="inputFilter()"
            size="20px"
            color="dark"
          ></vs-icon>
        </vs-col>
      </vs-row>
      <vs-row
        id="center"
        class="mb-2"
        style="display: flex; align-items: center"
        :key="index"
        v-for="(item, index) in selectFilter"
      >
        <vs-icon
          icon="delete"
          id="btns"
          @click="removeItem(item, index, filtervalue)"
          size="20px"
          color="danger"
        ></vs-icon>
        <h6 class="mr-2 ml-1">{{ item }} :</h6>
        <input
          class="inputx w3-input"
          style="width: 260px"
          @keydown.enter="inputFilter()"
          v-model="filtervalue[index]"
        /> </vs-row
      ><br />

      <vs-table
        search
        :data="alertlist"
        vs-lg="12"
        vs-sm="4"
        vs-xs="12"
        style="background-color: #f2f3f4; border-radius: 20px"
      >
        <!-- <template slot="header">
          <div
            class="a"
            style="
              margin-left: 1%;
              width: auto;
              margin-top: 1%;
              margin-bottom: 1%;
              border-radius: 5px;
            "
          >
            <vs-dropdown>
              <h6 class="a-icon" href.prevent>
                Filters :
                {{ this.network }}
                <vs-icon class icon="expand_more" size="12px"></vs-icon>
              </h6>
              <vs-dropdown-menu>
                <vs-dropdown-item
                  v-for="item in nwlist"
                  :key="item.id"
                  @click="actionchange(item.id, item.name)"
                >
                  {{ item.name }}</vs-dropdown-item
                >
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
          <vs-spacer />
        </template> -->
        <template slot="thead">
          <vs-th style="padding: 0px"> Disarm Button </vs-th>
          <vs-th
            v-for="item in headerAlert"
            :key="item"
            sort-key="alertid"
            style="padding: 0px"
          >
            {{ item }}
            <span><vs-icon icon="unfold_more" size="16px"></vs-icon></span>
          </vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr v-for="(item, i) in data" :key="item.i">
            <vs-td style="width: 200px">
              <!-- <vs-button
                v-if="item.alertstatus"
                class="text-warning"
                color="warning"
                type="flat"
                icon="notifications_off"
                @click="disarm(aid[i])"
                >Disarm</vs-button
              > -->
              <vs-button
              v-if="item.alertstatus"
                class="text-warning"
                color="warning"
                type="flat"
                icon="notifications_off"
                @click="disarm(aid[i])"
                >Disarm</vs-button
              >
              <vs-button
                color="success"
                type="flat"
                @click="viewAlert(item)"
                icon="add_circle"
                >View</vs-button
              >
            </vs-td>
            <vs-td :data="item.alertid">
              {{ item.alertid }}
            </vs-td>
            <vs-td :data="item.alertname">
              {{ item.alertname }}
            </vs-td>
            <vs-td :data="item.message">
              {{ item.message }}
            </vs-td>
            <vs-td
              :data="item.sensorname"
              @click="sensorRoute(item.sensorname)"
            >
              <a
                id="aColor"
                class="cursor-pointer"
                @click="viewsensor(item, aid[i])"
                ><vs-icon
                  class="mr-2"
                  icon="signal_cellular_alt"
                  size="16px"
                ></vs-icon
                >{{ item.sensorname }}</a
              >
            </vs-td>
            <!-- <vs-td :data="item.lastdata">
              <div v-if="item.lastdata[0]">
                <div
                  v-for="(data, index) in Object.keys(item.lastdata[0])"
                  :key="index"
                >
                  <div v-if="data != 'time' && data != 'date' && data != 't'">
                    {{ data }}: {{ item.lastdata[0][data] }}
                  </div>
                </div>
              </div>
            </vs-td> -->
            <vs-td :data="item.timestamp">
              {{ item.timestamp }}
            </vs-td>
            <vs-td v-if="item.alertstatus"> Armed </vs-td>
            <vs-td v-else> Disarmed </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vs-card>
  </div>
</template>

<script>
import XLSX from "xlsx"; // import xlsx
import html2pdf from "html2pdf.js";
import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";
export default {
  name: "Sensor",
  data: () => ({
    nwlist: [],
    sensorlist: [],
    network: "",
    role: "",
    b: true,
    filtervalue: [],
    sensorlist: [],
    selectFilter: [],
    filter_input: [
      {
        alertname: "",
        alertid: "",
        message: "",
        sensorname: "",
        lastdata: "",
        timestamp: "",
        alertstatus: "",
      },
    ],
    filter_list: [],
    counter: 0,
    header: [
      "Disarm Button",
      "Alert Id",
      "Alert Name",
      "Condition",
      "Sensor Name",
      "Reading Data",
      "Alert Timestamp",
      "Status",
    ],
    headerAlert: [
      "AlertId",
      "Alert Name",
      "Condition",
      "Sensor Name",
      "Alert Timestamp",
      "Status",
    ],
    // alertlist: [{"name":"Temp Alert","con":"Temperature > 25","sensname":"Office Temp","data":"26C","timestamp":"2020-8-13 16:23:45","status":true},
    // {"name":"Humid Alert","con":"Humidity > 60","sensname":"Humidity Sensor","data":"62%","timestamp":"2020-9-17 09:10:06","status":true}],
    alertlist: [],
    aid: [],
    sensorId: [],
    primeTable: [],
    dataBody: [],
    dataExport: [],
    dataAlert: [],
  }),

  methods: {
     viewAlert(item){
       console.log(item)
       this.dataAlert = item
       console.log(this.dataAlert)
      this.$session.set('dataAlert',this.dataAlert)
      // this.$session.set('statussensor',item.active)
      // this.$session.set('nwid', item.nwid)
      // this.$session.set('sensorname', item.name)
      // this.$session.set('sensorid', item.serial_id)
      // this.$session.set('gatewayid', item.gatewayid)
      // this.$session.set('type', item.type)
      // this.$session.set('lora', item.lora)
      // console.log(this.network,item)
      this.$router.push({
        name: 'ViewAlert',
        params:  {dataAlert : this.dataAlert}
      })
    },
    sensorRoute(sensor) {
      console.log(sensor);
    },
    viewsensor(item, id) {
      console.log(item);
      console.log(id);
      this.$http
        .get(this.$url + "sensorid/" + this.$session.get("token"))
        .then((result) => {
          let sensor = result.data.filter(
            (sensor) => sensor.id == item.sensorid
          );
          if (sensor) {
            let item = sensor[0];
            this.$session.set("nwname", item.network);
            this.$session.set("statussensor", item.active);
            this.$session.set("nwid", item.nwid);
            this.$session.set("sensorname", item.name);
            this.$session.set("sensorid", item.serial_id);
            this.$session.set("gatewayid", item.gatewayid);
            this.$session.set("type", item.type);
            this.$session.set("lora", item.lora);
            this.$session.set("id", item.id);
            this.$router.push({
              name: "SensorDashboard",
              params: {
                // nwname: sensor.network,
                nwid: item.nwid,
                sensorid: item.serial_id,
                gatewayid: item.gatewayid,
                type: item.type,
                id: item.id,
              },
            });
          }
        });
    },
    print() {
      var tempData = "";
      this.alertlist.forEach((element) => {
        element.lastdata.forEach((data) => {
          Object.keys(data).forEach((key) => {
            tempData += key + " " + data[key] + " ";
          });
          this.dataBody.push({
            alertname: element.alertname,
            message: element.message,
            sensorname: element.sensorname,
            alertname: element.alertname,
            lastdata: tempData,
            message: element.message,
            timestamp: element.timestamp,
            status: element.alertstatus,
          });
          tempData = "";
        });
      });
      console.log("aaaa");
      console.log(this.dataBody);
      var doc = new jsPDF("p", "pt");
      doc.setFontSize(11).text("Alert List", 40, 40);
      var newDat = moment().format("MM/DD/YYYY hh:mm:ss");
      doc.setFontSize(7).text(505, 25, newDat);
      var values = this.dataBody.map((elemento) => Object.values(elemento));
      console.log(values);
      doc.autoTable({
        theme: "striped",
        headStyles: { fillColor: [105, 181, 83], textColor: [255, 255, 255] },
        styles: { fontSize: 8, theme: "plain" },
        head: [
          [
            "Alert Name",
            "Condition",
            "Sensor Name",
            "Reading Data",
            "Alert Timestamp",
            "Status",
          ],
        ],
        body: values,
        margin: { top: 50 },
      });
      doc.autoPrint();
      doc.output("dataurlnewwindow");
      this.dataBody = [];
    },
    exportPDF() {
      var tempData = "";
      this.alertlist.forEach((element) => {
        element.lastdata.forEach((data) => {
          Object.keys(data).forEach((key) => {
            tempData += key + " " + data[key] + " ";
          });
          this.dataBody.push({
            alertname: element.alertname,
            message: element.message,
            sensorname: element.sensorname,
            alertname: element.alertname,
            lastdata: tempData,
            message: element.message,
            timestamp: element.timestamp,
            status: element.alertstatus,
          });
          tempData = "";
        });
      });
      console.log(this.dataBody);
      var doc = new jsPDF("p", "pt");
      doc.setFontSize(11).text("Alert List", 40, 40);
      var newDat = moment().format("MM/DD/YYYY hh:mm:ss");
      doc.setFontSize(7).text(505, 25, newDat);
      var values = this.dataBody.map((elemento) => Object.values(elemento));
      console.log(values);
      doc.autoTable({
        theme: "striped",
        headStyles: { fillColor: [105, 181, 83], textColor: [255, 255, 255] },
        styles: { fontSize: 8, theme: "plain" },
        head: [
          [
            "Alert Name",
            "Condition",
            "Sensor Name",
            "Reading Data",
            "Alert Timestamp",
            "Status",
          ],
        ],
        body: values,
        margin: { top: 50 },
      });
      doc.save("exportAlertList.pdf");
      this.dataBody = [];
    },
    // export xlsx
    onExport() {
      var tempData = "";
      this.alertlist.forEach((element) => {
        element.lastdata.forEach((data) => {
          Object.keys(data).forEach((key) => {
            tempData += key + " " + data[key] + " ";
          });
          this.dataExport.push({
            alertname: element.alertname,
            message: element.message,
            sensorname: element.sensorname,
            alertname: element.alertname,
            lastdata: tempData,
            message: element.message,
            timestamp: element.timestamp,
            status: element.alertstatus,
          });
          tempData = "";
        });
      });
      const dataWS = XLSX.utils.json_to_sheet(this.dataExport);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, dataWS);
      XLSX.writeFile(wb, "exportAlert.xlsx");
      this.dataExport = [];
    },
    removeItem(item, index, filtervalue) {
      var count = 0;
      //--------------Delete Filter Value----------------
      this.$delete(this.selectFilter, index);
      this.$delete(this.filtervalue, index);
      //------------------Function-------------------------
      function matchFilter(filter_input) {
        let matchFilter = {};
        for (let key in filter_input[0]) {
          if (filter_input[0][key] === undefined) {
            console.log("undefined");
          } else if (filter_input[0][key].length !== 0) {
            matchFilter[key] = filter_input[0][key];
          }
        }
        return matchFilter;
      }
      function deletefilter(item, filter_input) {
        if (item == "Alert Name") {
          filter_input[0].alertname = "";
        }
        if (item == "Alert Id") {
          filter_input[0].alertid = "";
        } else if (item == "Condition") {
          filter_input[0].message = "";
        } else if (item == "Sensor Name") {
          filter_input[0].sensorname = "";
        } else if (item == "Reading Data") {
          filter_input[0].lastdata = "";
        } else if (item == "Alert Timestamp") {
          filter_input[0].timestamp = "";
        } else if (item == "Status") {
          filter_input[0].status = "";
        }
      }
      function lastDataSearch(inputSearch, data) {
        let jsonData = JSON.stringify(data.lastdata); //[{temp: xx},{humid: xx}] => JSON
        let strSearch = inputSearch.toLowerCase(inputSearch);
        //Remove character from string
        jsonData = jsonData
          .toLowerCase(jsonData)
          .replace(/\"/g, "")
          .replace(/\:/g, "")
          .replace(/\,/g, "");
        strSearch = strSearch.replace(/\:/g, "").replace(/\ /g, "");
        if (jsonData.includes(strSearch) == true) {
          console.log(jsonData);
          console.log(strSearch);
          return true;
        } else {
          return false;
        }
      }
      //---------------------Delete--------------------------
      deletefilter(item, this.filter_input);
      var filter_data = this.filter_input[0];
      //-----------------Check filterinput data--------------
      for (let i in filter_data) {
        if (filter_data[i].length != 0) {
          count += 1;
        }
      }
      //---------------When no filter applied Case 1-----------
      if (count == 0) {
        this.alertlist = this.primeTable;
        this.counter = 0;
        console.log("case 1");
      }
      //Display previous filter apply
      else {
        //Remove Empthy Key
        var matchFilter = matchFilter(this.filter_input);
        let matchAlert = [];
        let counter = 0;
        //Search
        for (let key in matchFilter) {
          if (counter == 0) {
            for (let index in this.primeTable) {
              if (key === "lastdata") {
                console.log("Reading Data");
                let matchLastData = lastDataSearch(
                  matchFilter[key],
                  this.primeTable[index]
                );
                if (matchLastData == true) {
                  matchAlert.push(this.primeTable[index]);
                }
              } else if (key === "alertid") {
                let inputId = parseInt(matchFilter[key]);
                let searchId = this.alertlist[index][key];
                if (inputId == searchId) matchAlert.push(this.alertlist[index]);
              } else {
                let inputStr = matchFilter[key].toLowerCase(matchFilter[key]);
                let alertListStr = this.primeTable[index][key].toLowerCase(
                  this.primeTable[index][key]
                );
                if (alertListStr.includes(inputStr) === true) {
                  matchAlert.push(this.primeTable[index]);
                }
              }
            }
            counter += 1;
          } else {
            matchAlert = matchAlert.filter(
              (alert) =>
                alert[key]
                  .toLowerCase(alert[key])
                  .includes(matchFilter[key].toLowerCase(matchFilter[key])) ===
                true
            );
          }
        }
        console.log(matchAlert);
        //Display
        this.alertlist = matchAlert;
        console.log("case 2");
      }
    },
    inputFilter() {
      var count = 0;
      var matchAlert = [];

      //Function
      function addFilter(item, filtervalue, filter_input) {
        if (item == "Alert Name") filter_input[0].alertname = filtervalue;
        else if (item == "Alert Id") filter_input[0].alertid = filtervalue;
        else if (item == "Condition") filter_input[0].message = filtervalue;
        else if (item == "Sensor Name")
          filter_input[0].sensorname = filtervalue;
        else if (item == "Reading Data") filter_input[0].lastdata = filtervalue;
        else if (item == "Alert Timestamp")
          filter_input[0].timestamp = filtervalue;
        else if (item == "Status") filter_input[0].alertstatus = filtervalue;
      }
      function matchFilter(filter_input) {
        let matchFilter = {};
        for (let key in filter_input[0]) {
          if (filter_input[0][key] === undefined) console.log("undefined");
          else if (filter_input[0][key].length !== 0)
            matchFilter[key] = filter_input[0][key];
        }
        return matchFilter;
      }
      function convertAlertKeytoColumnName(key) {
        if (key == "alertname") return "Alert Name";
        else if (key == "alertid") return "Id";
        else if (key == "message") return "Condition";
        else if (key == "sensorname") return "Sensor Name";
        else if (key == "lastdata") return "Reading Data";
        else if (key == "timestamp") return "Alert Timestamp";
        else if (key == "alertstatus") return "Status";
      }
      function lastDataSearch(inputSearch, data) {
        let jsonData = JSON.stringify(data.lastdata); //[{temp: xx},{humid: xx}] => JSON
        let strSearch = inputSearch.toLowerCase(inputSearch);
        //Remove character from string
        jsonData = jsonData
          .toLowerCase(jsonData)
          .replace(/\"/g, "")
          .replace(/\:/g, "")
          .replace(/\,/g, "");
        strSearch = strSearch.replace(/\:/g, "").replace(/\ /g, "");
        if (jsonData.includes(strSearch) == true) return true;
        else return false;
      }

      //Input Index and Filter Value to Filter_Input Array
      for (let index in this.selectFilter) {
        var item = this.selectFilter[index];
        var filtervalue = this.filtervalue[index];
        addFilter(item, filtervalue, this.filter_input);
      }

      //Remove Empthy Key
      var matchFilter = matchFilter(this.filter_input);

      //Search
      for (let key in matchFilter) {
        if (count == 0) {
          for (let index in this.alertlist) {
            if (key === "lastdata") {
              let matchLastData = lastDataSearch(
                matchFilter[key],
                this.alertlist[index]
              );
              if (matchLastData == true) {
                matchAlert.push(this.alertlist[index]);
              }
            } else if (key === "alertid") {
              let inputId = parseInt(matchFilter[key]);
              let searchId = this.alertlist[index][key];
              if (inputId == searchId) matchAlert.push(this.alertlist[index]);
            } else {
              let inputStr = matchFilter[key].toLowerCase(matchFilter[key]);
              let alertListStr = this.alertlist[index][key].toLowerCase(
                this.alertlist[index][key]
              );
              if (alertListStr.includes(inputStr) === true) {
                matchAlert.push(this.alertlist[index]);
              }
            }
          }
          count += 1;
        } else {
          matchAlert = matchAlert.filter(
            (alert) =>
              alert[key]
                .toLowerCase(alert[key])
                .includes(matchFilter[key].toLowerCase(matchFilter[key])) ===
              true
          );
        }
      }
      console.log(matchAlert);
      this.alertlist = matchAlert;
    },
    async actionchange(id, name) {
      this.network = name;
      if (name == "All Network") {
        await this.$http
          .get(this.$url + "sensorid/" + this.$session.get("token"))
          .then((result) => {
            this.sensorlist = result.data;
          });
      } else {
        await this.$http
          .get(this.$url + "sensors/" + id + "/" + this.$session.get("token"))
          .then((result) => {
            this.sensorlist = result.data;
          });
      }
      // eslint-disable-next-line no-console
      console.log(this.sensorlist);
    },
    disarm(id) {
      // console.log(id)
      this.$http
        .get(this.$url2 + "disarm/" + this.$session.get("username") + "/" + id)
        .then(() => {
          location.reload();
        })
        .catch((err) => {
          console.log(err);
          this.$vs.notify({
            title: "Disarm Error!",
            text: "Can't disarm this alert",
            color: "danger",
            position: "top-center",
            icon: "check",
          });
        });
    },
    link2(item) {
      this.$router.push({
        name: "ViewAlert",
        params: {
          user: item,
        },
      });
    },
    del(item) {
      this.$http
        .post(this.$url + "sensordel", {
          id: item.serial_id,
        })
        .then(() => {});
      this.$vs.notify({
        title: "Delete Network",
        text: "Complete!",
        color: "danger",
        position: "top-center",
        icon: "check",
      });
    },
  },
  components: {},
  async created() {
    this.role = this.$session.get("role");
    var tempel = {};
    // this.$http.get(this.$url+'getalertlog/'+this.$session.get('username')).then((result) => {
    //   console.log(result.data)
    // })
    await this.$http
      .get(this.$url + "network/" + this.$session.get("token"))
      .then((result) => {
        this.nwlist = result.data;
        this.nwlist.unshift({ id: 0, name: "All Network" });
        this.network = result.data[0].name;
      });
    await this.$http
      .get(this.$url + "sensorid/" + this.$session.get("token"))
      .then((result) => {
        this.sensorlist = result.data;
      });
    await this.$http
      .get(this.$url2 + "getalertlog/" + this.$session.get("username"))
      .then((result) => {
        result.data.forEach((element) => {
          let sensor = this.sensorlist.filter(
            (sensor) => sensor.name == element.sensorname
          );
          if (sensor.length == 0) console.log("no sensor found");
          let count = 0;
          element.alerthistory.forEach((el) => {
            count += 1;
            this.aid.push(element.id);
            this.sensorId.push(sensor[0].id);
            el.alertid = count;
            tempel = el;
            tempel.alertname = element.alertname;
            tempel.alertstatus = element.alertstatus;
            tempel.sensorname = element.sensorname;
            tempel.sensorid = sensor[0].id;
            this.alertlist.push(el);
            tempel = {};
          });
        });

        //Sort Alert By Date
        const sortByDate = (arr) => {
          const sorter = (a, b) => {
            //***********Sort Descending******************
            return (
              new Date(b.timestamp).getTime() - new Date(a.timestamp).getTime()
            );
          };
          arr.sort(sorter);
        };
        sortByDate(this.alertlist);

        //Format Alert Date
        this.alertlist.forEach((element) => {
          element.timestamp = this.$moment(element.timestamp).format(
            "YYYY-MM-DD HH:mm:ss"
          );
        });

        //Insert Id
        let countId = 0;
        this.alertlist.forEach((element) => {
          element.alertid = countId;
          countId += 1;
        });
        console.log(this.alertlist);

        //Set PrimeTable
        this.primeTable = this.alertlist;
      });
  },
};
</script>
<style scoped>
.vs-button{
  border-radius: 20px;
}
#aColor:hover {
  color: #32c040;
}
#aColor {
  color: #32c040;
}
#btns {
  cursor: pointer;
}
#center {
  display: flex;
  align-items: center;
}
button#dropdown-1_BV_toggle_.btn.dropdown-toggle.btn-secondary {
  border-radius: 5px;
}
.th .sort-th .th-sort-icon {
  color: white;
  padding: 0px;
}
#p {
  display: inline;
}
#v {
  display: none;
}
#center {
  display: flex;
  align-items: center;
}
@media screen and (max-width: 600px) {
  .a {
    /* background: pink; */
    width: 200px;
  }
  #v {
    display: inline;
  }
  #p {
    display: none;
  }
  .vuesax-app-is-ltr .vs-table--search-input {
    width: 100px;
    padding: o;
  }
  .vuesax-app-is-ltr .vs-table--search i {
    left: 15px;
  }
}
</style>
